import "bootstrap/dist/css/bootstrap.min.css";
import "./css/custom.css";
import "swiper/css";
import "swiper/css/pagination";
import { useRoutes } from "react-router-dom";
import { useSelector } from "react-redux";
import getRoutes from "./routes";
import { LocalDBProvider } from "./helpers/LocalDBContext";
import { useOnlineStatus, useFetchAndSyncData } from "./hooks";
import { useCallback, useEffect } from "react";
import { manageErrorLogs } from "./helpers/commonFunction";

const App = () => {
  const { isOnline } = useOnlineStatus();
  const localSUser = JSON.parse(localStorage.getItem("user"));
  const { user } = useSelector((state) => state.userReducer);
  const { uploadAndFetchData } = useFetchAndSyncData(false);

  useEffect(() => {
    if (isOnline && user?.user_id) {
      const intervalId = setInterval(
        handleUploadDBData,
        process.env.REACT_APP_API_CALL_TIME
      );
      return () => clearInterval(intervalId);
    }
  }, [isOnline, user]);
  const handleUploadDBData = useCallback(async () => {
    try {
      await uploadAndFetchData("");
    } catch (error) {
      manageErrorLogs(error);
    }
  }, []);

  const routing = useRoutes(getRoutes(localSUser ? user : null));
  return <LocalDBProvider>{routing}</LocalDBProvider>;
};

export default App;
